
import { defineComponent, PropType } from 'vue';
import type { DropdownItems } from '@white-label-types/dropdown';
import IconButton from '@white-label-icon/icon-button';

export default defineComponent({
  name: 'DropdownList',
  components: {
    IconButton,
  },
  props: {
    value: {
      type: String,
      required: true,
    },

    items: {
      type: Array as PropType<DropdownItems>,
      required: true,
    },

    dropdownOpened: {
      type: Boolean,
      default: false,
    },

    mobilePopUpTitle: {
      type: String,
      required: false,
      default: '',
    },

    matchWidth: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
      value(newVal) {
          if (newVal) {
              this.updateScrollPosition();
          }
      },
  },
  methods: {
    updateScrollPosition(): void {
      const dropdownListContent = this.$refs.dropdownContent;
      if (!dropdownListContent) {
        return;
      }

      const currentActiveIndex = this.items.findIndex((item) => item.name === this.value);
      const lastIndex = this.items.length - 1;
      const itemHeight = dropdownListContent.querySelector('.dropdown-item').clientHeight;
      let scrollOffset = itemHeight * (currentActiveIndex - 1);
      if (currentActiveIndex === 0) {
        scrollOffset = 0;
      }

      if (currentActiveIndex === lastIndex) {
        scrollOffset = lastIndex * itemHeight;
      }

      dropdownListContent.scrollTop = scrollOffset;
    },

    //custom emit to handle esc key to close dropdown and keep the focus on dropdown wrapper for accessibility
    handleEscKey(): void {
      this.$emit('esc-pressed');
    }
  }
});
